import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const lpgOrder: IMcAppType = {
  name: "lpgOrder_SAP",
  path: "/my-account/lpg/order",
  parameters: {
    required: ["caid"],
    properties: { caid: CommonParameters.caid },
  },
  description: "Place an LPG order",
  navFlow: NavFlow.STANDARD,
  parent: Tab.MORE,
  title: "LPG Order",
  conditions: {
    intent: "lpgOrder",
    customerType: CustomerType.sap,
  },
};
